import script from "./templateBigScreen1.vue?vue&type=script&setup=true&lang=js"
export * from "./templateBigScreen1.vue?vue&type=script&setup=true&lang=js"

import "./templateBigScreen1.vue?vue&type=style&index=0&id=be465bb2&lang=less"

const __exports__ = script;

export default __exports__